import { render, staticRenderFns } from "./RxProtocolManager.vue?vue&type=template&id=c7d9d59e"
import script from "./RxProtocolManager.vue?vue&type=script&lang=js"
export * from "./RxProtocolManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports